import i18n from 'config/i18n';
import { INotify, INotifyTypes } from 'types/app';

export const STRIP_HTML_REGEX = /<\/?[^>]+(>|$)/g;
export const FREE_EMAIL_REGEX = /@(hotmail|yahoo|gmail|outlook|icloud|aol|protonmail|yandex)\.com/;
export const UUID_REGEX =
  /[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}/g;
export const USER_FEED_NAME: string = i18n.t('components:timeline');
export const USER_FEED_ID = '0';

export const CONNECTION_SUCCESS_MESSAGE = 'connectionSuccess';
export const CONNECTION_FAILURE_MESSAGE = 'connectionFailure';

export const SHARE_LOADING_MESSAGE = 'shareLoading';
export const SHARE_SUCCESS_MESSAGE = 'shareSuccess';

export const NO_NAME: string = i18n.t('components:unknownName');
export const DEFAULT_SORT = true;

// TypeScript helpers
export const NULL = null as null;
export const ARRAY = [] as [];

export const APP_IMAGES = {
  Icon: 'icon.png',
  Invalid: '404.png',
  Logo: 'logo.png',
  ReadOnly: 'read-only.png',
  SocialLoading: 'social-loading.png',
  Welcome1: 'welcome1.png',
  Welcome2: 'welcome2.png',
  Error1: 'error-1.png',
  Error2: 'error-2.png',
  Error3: 'error-3.png',
  Error4: 'error-4.png',
};

export const TWITTER_LIMIT = 280;
export const FACEBOOK_LIMIT = 1000;
export const LINKEDIN_LIMIT = 1300;
export const BITLY_OFFSET = 25;
export const TWITTER_LIMIT_WITH_LINK = 257;
export const INSTAGRAM_LIMIT = 2200;

export const FOLLOW_QUERIES_LIMIT = 25;
export const GROUP_MEMBERS_LIMIT = 50;
export const FEED_LIMIT = 10;

export const INVITE_REFERRAL_LIMIT = 160;

export const DEFAULT_NOTIFY_OPTIONS: INotify = {
  component: null,
  message: null,
  i18n: null,
  duration: 2000,
  show: false,
  type: INotifyTypes.Info,
};

export const DISCLOSURE_SPACE_COUNT = 1;
export const PAGINATION_ROOT_MARGIN = '0px 0px 400px 0px';

export const NOTIFICATION_POPUP_LIMIT = 7;
export const NOTIFICATION_INBOX_LIMIT = 24;

export const EMPTY_SLATE_EDITOR = '<p></p>';

export const PRE_SELF_SERVE_USER_CREATED_AT_TIME = 1630459908;

export const ROOT_DOMAIN_LABEL_FOR_LOGOUT = 'es-root-epXilnud';

export const PRODUCT_FEEDBACK_URL = 'https://feedback.everyonesocial.com/';

export const ACCESS_KEY = 'access_key';

export const SHORTENED_NUMBER_CUTOFF = 100000;
